import { useEffect } from 'react';
import AllRoute from '../router'
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { captureAttributionFromUrl } from '../../utils/attribution';

const App = () => { 
  useEffect(() => {
    console.log("APP START:", window.location.href);
    captureAttributionFromUrl();
  }, []);

  return (
    <div className="App" id='scrool'>
          <AllRoute/>
          <ToastContainer/>
    </div>
  );
}

export default App;